import React, { PureComponent } from 'react';

import { filterProps } from '@lglp/components';
import { withRouter } from 'react-router-dom';

import { getUrlFromDocument } from '../../../helpers/routes/mapping';
import Link from './Link';

export class DocumentLinkComponent extends PureComponent {
  static displayName = 'DocumentLinkComponent';

  static handledProps = [
    'document',
    'location',
    'staticContext',
    'history',
    'match',
    'keepFilter',
  ];

  render() {
    const { document, match, location, children, keepFilter } = this.props;
    const rest = filterProps(DocumentLinkComponent, this.props);

    return (
      <Link
        to={getUrlFromDocument(document, { match, location }, keepFilter)}
        {...rest}
      >
        {children}
      </Link>
    );
  }
}

export default withRouter(DocumentLinkComponent);
